import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationGallery } from '../../components/locations/LocationGallery';
import { SaginawProgramsPricing } from '../../components/locations/SaginawProgramsPricing';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function SaginawPage() {
  const location = getLocationById('saginaw');
  if (!location) {
    return <div data-id="element-971">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-972">
      <Header data-id="element-973" />

      <main data-id="element-974">
        <LocationPageHero location={location} data-id="element-975" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-976" />
        {location.galleryImages && location.galleryImages.length > 0 && <LocationGallery images={location.galleryImages} locationName={location.name} data-id="element-977" />}
        <SaginawProgramsPricing data-id="element-978" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-979" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-980" />
      </main>

      <Footer data-id="element-981" />
    </div>;
}